import { getNearestUpperMultiple } from '@cian/utils';
import { IAppState } from '../../redux';
import { selectCurrentServiceCost } from './selectCurrentServiceCost';
import { selectNextServiceCost } from './selectNextServiceCost';
import { selectStepBetByServiceId } from './selectStepBetByServiceId';

export function selectNextLevelServiceBet(state: IAppState): number {
  const {
    auction: { currentBet },
  } = state;

  const currentServiceCost = selectCurrentServiceCost(state);
  const nextServiceCost = selectNextServiceCost(state);

  if (!currentServiceCost || !nextServiceCost) {
    return 0;
  }

  const stepBet = selectStepBetByServiceId(nextServiceCost.serviceId, state);

  const nextBet = currentServiceCost.cost + currentBet - nextServiceCost.cost;
  const nextMultipleBet = getNearestUpperMultiple(nextBet, stepBet);

  return Number(nextMultipleBet);
}
